import React,{Component} from 'react';
import DBHandler from '../DBHandler';

import {Paper,IconButton,Icon,SvgIcon,
Typography,Button} from '@material-ui/core';
import ICONOPDF from '@material-ui/icons/PictureAsPdf';
import ICONODESCARGA from '@material-ui/icons/ArrowDropDownCircle';
import ICONOCARPETA from '@material-ui/icons/Folder';



import IIBB from '../pdfs/RetencionIIBB';
import Ganancias from '../pdfs/RetencionGanancias';
import SUSS from '../pdfs/RetencionSUSS';
import AFIP from '../pdfs/AFIP';
import AportesMedicos from '../pdfs/AportesMedicos';
import DerechoOficina from '../pdfs/DerechosOficina';
import OrdenanzaFiscal from '../pdfs/OrdenanzaFiscal';
import SeguridadHigiene from '../pdfs/SeguridadeHigiene';
import ServiciosGenerales from '../pdfs/ServiciosGenerales';
import DerechosOcupacion from '../pdfs/DerechosdeOcupacion';

import {PDFDownloadLink, BlobProvider} from '@react-pdf/renderer'

let URLBASE = 'retenciones/'


export default class ListaRecibos extends Component{

    constructor(props){
        super(props);

        this.state={
            retlistadas:[],
            retenciones:{},
            cuit:props.cuit,
            esperandoRetenciones:true,
            deduc:null,
            op:null,
            opFinal:null,
            ejercicio:null,
            tabla:null,
            blob:null,
        }
        this.db = new DBHandler();
        
        this.pedirRetenciones.bind(this)();
    }

    componentWillReceiveProps(props){
        this.setState({
            cuit:props.cuit,
        })
    }

    pedirRetenciones(){
        this.db.enviarPeticion(
            this.cargarRetenciones.bind(this),
            URLBASE + 'listar',
            'POST',
            {
                'usuario':this.state.cuit
            }
        )
    }

    pedirComprobantes(){
        this.db.enviarPeticion(
            this.cargarComprobantes.bind(this),
            'comprobantes/listar',
            'POST',
            {
                'usuario':this.state.cuit
            }
        )
    }


    ordenarPorFecha(a,b){
        let diaA = a.substr(0,2);
        let diaB = b.substr(0,2);
        let mesA = a.substr(3,2);
        let mesB = b.substr(3,2);
        let anioA = a.substr(6,4);
        let anioB = b.substr(6,4);

        if (anioA > anioB){
            return -1
        }
        else if(anioA < anioB){
            return 1
        }
        else if(mesA > mesB){
            return -1
        }
        else if(mesA < mesB){
            return 1
        }
        else if(diaA > diaB){
            return -1
        }
        else if(diaA < diaB){
            return 1
        }
        else{
            return -1
        }

    }

    cargarComprobantes(datos){
        
        let agrup = this.state.retenciones;
        
        for (let x= 0; x < datos.length; x++){
            let act = datos[x];
            let fecha = act.fecha;
            let op = act.nro_op;
            if( (fecha + op in agrup)){
                agrup[fecha + op].push(act);
            }
        }

        this.setState({retenciones:agrup});

    }

    cargarRetenciones(datos){
        let ret = {}
        console.log(datos)
        for (let x = 0; x < datos.length; x++){
            let act = datos[x];
            let op = act.nro_op;
            let fecha = act.fecha;
            if ( ! (fecha + op in ret) ){
                ret[fecha + op] = [];
            }
            ret[fecha + op].push(act);
        }
        let lista = Object.keys(ret);
        lista.sort(this.ordenarPorFecha);

        this.setState({
            retlistadas:lista,
            retenciones:ret,
            esperandoRetenciones:false,
            op:null,
            deduc:null,
            ejercicio:null,
            blob:null,
        })//,this.pedirComprobantes.bind(this))
    }

    elegir(op,deduc,ejercicio,tabla){
        this.setState({
            deduc:deduc,
            opFinal:op,
            ejercicio:ejercicio,
            tabla:tabla,
        })
        if( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i))
        {
            //funcion para celular
        }
    }


    cargarRetencion(datos){
        let recibo =null// generarDescargaRecibo(datos.datos);
        this.setState({blob:recibo})
    }


    volverListado(){

        if(this.state.deduc !== null){
            this.setState({
                opFinal:null,
                deduc:null,
                ejercicio:null,
                blob:null,
            })
        }
        else{
            this.setState({
                op:null,
                deduc:null,
                ejercicio:null,
                blob:null,
            })
        }
    }

    cargarRecibos(datos){
        let recibos = datos.recibos
        for (let x = 0; x < recibos.length; x++){
            if(recibos[x][0][1] === '-'){
                recibos[x][0] = '0' + recibos[x][0]
            }
        }


        if (datos.recibos.length > 0){
            this.setState({recibos:datos.recibos,esperandoRecibos:false});   
        }
        else{
            this.setState({esperandoRecibos:false});
        }
    }

    render(){

        let recibos =<div style={{textAlign:'center',height:'inherit',width:'inherit'}}>
                        <span>Esperando Comprobantes</span>
                     </div>
        if (this.state.retlistadas.length >0){
            if(this.state.op === null ){
                recibos = this.state.retlistadas.map((elem,indice)=><TarjetaOp nro_op={elem.substr(10)} 
                    elegir={()=>this.setState({op:elem})} key={indice} fecha={elem.substr(0,10)}
                />)
            }
            else if (this.state.op !== null && this.state.deduc === null){
                recibos = 
                    <div>
                        <AgrupamientoRetenciones nro_op={this.state.op}  
                            elegir={this.elegir.bind(this)} 
                            retenciones={this.state.retenciones[this.state.op]}   
                        />
                    </div>
                
            }
        }
        
        else if( this.state.esperandoRetenciones === false){
            recibos =<div style={{textAlign:'center',height:'inherit',width:'inherit'}}>
                        <span> No hay recibos disponibles</span>
                    </div>
        }
        let blob = null

        if( this.state.op !== null && this.state.deduc !== null){
            if (this.state.deduc === 3){
                recibos = <Ganancias
                    op={this.state.opFinal}
                    tipo_deduc={this.state.deduc}
                    ejercicio={this.state.ejercicio}
                    tabla={this.state.tabla}
                ></Ganancias>
            }
            else if (this.state.deduc === 6){
                recibos = <IIBB
                    op={this.state.opFinal}
                    tipo_deduc={this.state.deduc}
                    ejercicio={this.state.ejercicio}
                    tabla={this.state.tabla}
                    
                ></IIBB>
            }

            else if (this.state.deduc === 9){
                recibos = <OrdenanzaFiscal
                    op={this.state.opFinal}
                    tipo_deduc={this.state.deduc}
                    ejercicio={this.state.ejercicio}
                    tabla={this.state.tabla}
                />
            }

            else if (this.state.deduc === 36){
                
                recibos = <AportesMedicos 
                    op={this.state.opFinal}
                    tipo_deduc={this.state.deduc}
                    ejercicio={this.state.ejercicio}
                    tabla={this.state.tabla}
                />
            }
            else if (this.state.deduc === 37){
                
                recibos = <DerechoOficina 
                    op={this.state.opFinal}
                    tipo_deduc={this.state.deduc}
                    ejercicio={this.state.ejercicio}
                    tabla={this.state.tabla}
                />
            }

            else if (this.state.deduc === 777 ||
                    this.state.deduc === 831  ||
                    this.state.deduc === 900
                ){
                    recibos = <AFIP
                        op={this.state.opFinal}
                        tipo_deduc={this.state.deduc}
                        ejercicio={this.state.ejercicio}
                        tabla={this.state.tabla}
                    />
                }
            else if (this.state.deduc === 20){
                recibos = <ServiciosGenerales 
                    op={this.state.opFinal}
                    tipo_deduc={this.state.deduc}
                    ejercicio={this.state.ejercicio}
                    tabla={this.state.tabla}
                />
            }

            else if (this.state.deduc === 22 || this.state.deduc === 23){
                recibos = <SeguridadHigiene 
                    op={this.state.opFinal}
                    tipo_deduc={this.state.deduc}
                    ejercicio={this.state.ejercicio}
                    tabla={this.state.tabla}
                />
            }

            else if (this.state.deduc === 38){
                recibos = <DerechosOcupacion 
                    op={this.state.opFinal}
                    tipo_deduc={this.state.deduc}
                    ejercicio={this.state.ejercicio}
                    tabla={this.state.tabla}
                />
            }

            else {
                recibos = <SUSS
                    op={this.state.opFinal}
                    tipo_deduc={this.state.deduc}
                    ejercicio={this.state.ejercicio}
                    tabla={this.state.tabla}
                    
                ></SUSS>
            }
        }


        return(
            <div style={{marginTop:'50px'}}>
                {this.state.op !== null ? <Button onClick={this.volverListado.bind(this)}
                    color='secondary' fullWidth variant='contained'
                >Volver al Listado</Button>:null}
                {recibos}   
                {blob}
            </div>
        )
    }
}

class TarjetaOp extends Component{
    constructor(props){
        super(props);
        this.state={
            nro_op:props.nro_op,
            fecha:props.fecha,
        }
        this.elegir=props.elegir;
    }

    render(){
        return< Paper style={{display:'inline-block',width:'150px',height:'180px',margin:'5px'}}>
                    <div style={{position:'relative',textAlign:'center',width:'150px',top:'35px'}} ><Icon  ><ICONOCARPETA/></Icon></div>
                    <div style={{position:'relative',top:'40px',left:'0px'}}>
                        <Typography>Nº Repa:{this.state.nro_op}</Typography>
                        <Typography>{this.state.fecha}</Typography>
                        <IconButton  style={{display:'inline-block'}} size='small' 
                        onClick={
                            ()=>{
                                this.elegir(this.state.nro_op)
                            }
                        } >
                            <Icon> <ICONODESCARGA/> </Icon>
                        </IconButton>
                    </div>
                </Paper>
    }
}



class AgrupamientoRetenciones extends Component{
    constructor(props){
        super(props);
        this.state={
            retenciones:props.retenciones,
            nro_op:props.nro_op,
        }
        this.elegir = props.elegir;
        this.volver = props.volver;
    }

    componentWillReceiveProps(props){
        this.setState({
            retenciones:props.retenciones,
            nro_op:props.nro_op,
        })
    }

    render(){
        return <div>
                <Typography>Recibos Asociados al REPA Nº {this.state.nro_op.substr(10)}</Typography>
                <div>
                    
                    {this.state.retenciones.map((elem,ind)=>
                        <TarjetaRecibo  codigo_deduc={elem.codigo_deduc} nro_op={elem.nro_op}
                            tipo_deduc={elem.tipo_deduc} fecha={elem.fecha} ejercicio={elem.ejercicio}
                             nro_deduc={elem.nro_deduc} elegir={this.elegir} tabla={elem.tabla}
                            key={ind}
                        />)}
                </div>
        </div>
    }
}


class TarjetaRecibo extends Component{
    constructor(props){
        super(props);
        this.state={
            nro_op:props.nro_op,
            fecha:props.fecha,
            ejercicio:props.ejercicio,
            tipo_deduc:props.tipo_deduc,
            codigo_deduc:props.codigo_deduc,
            nro_deduc:props.nro_deduc,
            tabla:props.tabla,
        }
        this.elegir = props.elegir;
    }

    componentWillReceiveProps(props){
        this.setState(
            {
                nro_op:props.nro_op,
                fecha:props.fecha,
                ejercicio:props.ejercicio,
                tipo_deduc:props.tipo_deduc,
                codigo_deduc:props.codigo_deduc,
                nro_deduc:props.nro_deduc,
                tabla:props.tabla
            }
        )
    }

    generarArchivo(data){
        
        let blob = data;
        let nombre = this.state.nro_deduc;
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = nombre;
        link.click();
    }

    descargar(archivo){
        
        
        let con = new XMLHttpRequest();
        con.open('POST','http://retenciones.brown.gob.ar/',true);
        con.responseType = 'blob';
        con.onload = function(event){
            let blob = con.response;
            let nombre = archivo;
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = nombre;
            link.click();
        }
        con.setRequestHeader('Content-type','application/json')
        con.send(JSON.stringify({'archivo':archivo}));
    }

    render(){
        return (
            <Paper style={{display:'inline-block',width:'150px',height:'180px',margin:'5px'}}>
                <div style={{position:'relative',textAlign:'center',width:'150px',top:'35px'}} ><Icon  ><ICONOPDF/></Icon></div>
                <div style={{position:'relative',top:'40px',left:'0px'}}>
                    <Typography>{this.state.tipo_deduc !== 'Comprobante' ? 'Nº Compro:' + this.state.nro_deduc : 'Comprobante'}</Typography>
                    <Typography>{this.state.tipo_deduc}</Typography>
                    <Typography>{this.state.fecha}</Typography>
                    <IconButton  style={{display:'inline-block'}} size='small' 
                    onClick={
                        ()=>{
                            this.state.tipo_deduc !== 'Comprobante' ? 
                                this.elegir(this.state.nro_op,this.state.codigo_deduc,this.state.ejercicio,this.state.tabla)
                                :
                                this.descargar.bind(this)(this.state.nro_deduc) //viene a ser el archivo a descargar
                        }
                    } >
                        <Icon> <ICONODESCARGA/> </Icon>
                    </IconButton>
                </div>
            </Paper>
        )
    }
    
}